import { Component, Input } from '@angular/core';

@Component({
	selector: 'eif-upload-suppliers-instructions',
	templateUrl: './upload-suppliers-instructions-component.html',
	styleUrls: ['./upload-suppliers-instructions-component.scss'],
	standalone: false,
})
export class UploadSuppliersInstructionsComponent {
	@Input() showActiveAutomaticFundingRequestInfo: boolean = false;
}
